/* eslint-disable react/require-default-props */
import React from 'react';

import {
  PROPOSAL_STEPS,
  ProposalStep,
  RULES_LOCK_MESSAGE,
  proposalStepLabel,
} from 'services/ai_management_proposal';
import { Container } from './styles';

interface AiManagementProposalStepperProps {
  activeStep: ProposalStep;
  locked: boolean;
  editalHasRules: boolean;
  pendencies: Partial<Record<ProposalStep, number>>;
  resumeStep?: ProposalStep | null;
  onSelect: (step: ProposalStep) => void;
}

const pendencyLabel = (count: number) => `${count} ${count === 1 ? 'pendência' : 'pendências'}`;

// Etapas em linha, ligadas por um traço: ✓ na etapa sem pendências, ⚠ com "N pendências" na que
// ainda tem, a atual em destaque e cadeado enquanto as regras não forem validadas.
const AiManagementProposalStepper: React.FC<AiManagementProposalStepperProps> = ({
  activeStep,
  locked,
  editalHasRules,
  pendencies,
  resumeStep,
  onSelect,
}) => (
  <Container aria-label="Etapas da proposta">
    <ol className="step-list">
      {PROPOSAL_STEPS.map((step, index) => {
        const stepLocked = locked && step !== 'regras';
        const current = step === activeStep;
        const count = pendencies[step];
        const pending = !stepLocked && !current && count !== undefined && count > 0;
        const complete = !stepLocked && !current && count === 0;
        const label = proposalStepLabel(step, editalHasRules);
        let estado = '';
        if (current) estado = ' current';
        else if (pending) estado = ' pending';
        else if (complete) estado = ' complete';

        let circulo: React.ReactNode = index + 1;
        if (stepLocked) circulo = <i className="material-icons-outlined">lock</i>;
        else if (complete) circulo = <i className="material-icons-outlined">check</i>;
        else if (pending) circulo = <i className="material-icons-outlined">priority_high</i>;

        return (
          <React.Fragment key={step}>
            {index > 0 && <li className="step-line" aria-hidden="true" />}
            <li>
              <button
                type="button"
                className={`step${estado}`}
                onClick={() => onSelect(step)}
                disabled={stepLocked}
                title={stepLocked ? RULES_LOCK_MESSAGE : undefined}
                aria-current={current ? 'step' : undefined}
              >
                <span className="step-circle" aria-hidden="true">
                  {circulo}
                </span>
                <span className="step-text">
                  <span className="step-label">{label}</span>
                  {pending && <small>{pendencyLabel(count as number)}</small>}
                  {!stepLocked && step === resumeStep && !current && (
                    <small className="step-resume">Você parou aqui</small>
                  )}
                </span>
              </button>
            </li>
          </React.Fragment>
        );
      })}
    </ol>
  </Container>
);

export default AiManagementProposalStepper;
